import { supabase } from '../../../lib/supabase';

const ONBOARDING_UPDATED_EVENT = 'crm:onboarding-updated';

export type OnboardingSkipKey = 'whatsappSkipped' | 'funnelSkipped';

type OrgSettings = Record<string, unknown> & {
  onboarding?: {
    funnelCustomized?: boolean;
    whatsappSkipped?: boolean;
    funnelSkipped?: boolean;
  };
};

export async function markOnboardingStepSkipped(
  organizationId: string,
  key: OnboardingSkipKey,
): Promise<boolean> {
  const { data: org, error: fetchError } = await supabase
    .from('organizations')
    .select('settings')
    .eq('id', organizationId)
    .single();

  if (fetchError || !org) {
    console.error('[Onboarding] Failed to load settings for skip:', fetchError);
    return false;
  }

  const current = (org.settings as OrgSettings | null) ?? {};
  if (current.onboarding?.[key] === true) {
    window.dispatchEvent(new CustomEvent(ONBOARDING_UPDATED_EVENT));
    return true;
  }

  // .select() detects RLS no-op (0 rows, no error) — common for member/viewer
  const { data, error: updateError } = await supabase
    .from('organizations')
    .update({
      settings: {
        ...current,
        onboarding: { ...current.onboarding, [key]: true },
      },
    })
    .eq('id', organizationId)
    .select('id')
    .maybeSingle();

  if (updateError || !data) {
    console.error('[Onboarding] Failed to skip step:', updateError ?? 'no row updated (RLS?)');
    return false;
  }

  window.dispatchEvent(new CustomEvent(ONBOARDING_UPDATED_EVENT));
  return true;
}
